<div class="bg-light min-vh-100 d-flex flex-row align-items-center" *transloco="let t">
    <c-container>
      <c-row class="justify-content-center">
        <c-col md="6">
          <c-card-group>
            <c-card class="p-4">
              <c-card-body>
                <form [formGroup]="emailForm" cForm (ngSubmit)="submitEmail()">
                  <div class="text-center">
                    <img alt="Logo" src="../../../assets/images/newlogo.png" class="img-fluid" />
                  </div>
                  <h1>{{ t('Login to the Dashboard') }}</h1>
                  <p class="text-medium-emphasis">{{ t('Request a new password') }}</p>
                  <c-input-group class="mb-3">
                    <span cInputGroupText>
                      <svg cIcon name="cilUser"></svg>
                    </span>
                    <input
                      [formControlName]="'email'"
                      cFormControl
                      placeholder="{{ t('Email') }}"
                      [ngClass]="{ 'border-danger': submitted && f['email'].errors }"
                    />
                    <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                        {{ t('A valid email is required') }}
                    </div>
                  </c-input-group>

                  <div role="alert" *ngIf="okService.alert.message" [className]="'alert  alert-dismissible fade show alert-' + okService.alert.type">
                    {{okService.alert.message}}
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.clearAlert()"></button>
                  </div>

                  <c-row>
                    <c-col xs="6">
                      <button cButton class="px-4 text-white btn-info" type="submit">
                        {{ t('Request New Password') }}
                      </button>
                    </c-col>
                    <c-col class="text-right" xs="6">
                      <button cButton class="px-0" color="link"  routerLink="/login">
                        {{ t('Back to Login') }}
                      </button>
                    </c-col>
                  </c-row>
                </form>
              </c-card-body>
            </c-card>
          </c-card-group>
        </c-col>
      </c-row>
    </c-container>
  </div>
